<template>
  <svg :aria-label="ariaLabel" :data-qa="dataQA"
      :aria-hidden="ariaHidden"
      focusable="false"
      role="img"
      data-name="Black Hole"
      class="d-illustration d-illustration--black-hole" width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1442_184" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="10" y="10" width="180" height="180">
<rect x="10" y="10" width="179.965" height="179.965" rx="89.9824" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1442_184)">
<circle cx="22.9575" cy="87.7447" r="32.3937" :fill="`url(#${uniqueID}paint0_linear_1442_184)`"/>
<circle cx="70.4684" cy="117.979" r="16.5568" transform="rotate(119.221 70.4684 117.979)" :fill="`url(#${uniqueID}paint1_linear_1442_184)`"/>
<circle cx="62.7234" cy="70.748" r="8.59832" :fill="`url(#${uniqueID}paint2_linear_1442_184)`"/>
<circle cx="140.681" cy="77.6269" r="8.59832" :fill="`url(#${uniqueID}paint3_linear_1442_184)`"/>
<circle cx="28.3295" cy="135.522" r="8.59832" :fill="`url(#${uniqueID}paint4_linear_1442_184)`"/>
<circle cx="103.941" cy="21.1579" r="26.2749" :fill="`url(#${uniqueID}paint5_linear_1442_184)`"/>
<circle cx="155.551" cy="141.423" r="49.3103" :fill="`url(#${uniqueID}paint6_linear_1442_184)`"/>
<path d="M38.4783 21.3277C49.2397 10.588 67.5316 14.8344 72.4611 29.2166C77.6976 44.4946 64.0877 59.5702 48.3555 55.9181C32.6233 52.266 27.0467 32.7364 38.4783 21.3277Z" :fill="`url(#${uniqueID}paint7_linear_1442_184)`"/>
<path d="M91.0025 168.925C81.5139 183.943 58.6254 180.116 54.5389 162.828C51.2416 148.879 63.2212 136.076 77.3584 138.44C91.4956 140.803 98.6584 156.807 91.0025 168.925Z" :fill="`url(#${uniqueID}paint8_linear_1442_184)`"/>
<path d="M135.883 22.6523C138.563 11.9413 149.093 5.14664 159.957 7.11871C178.655 10.5131 183.545 35.0452 167.576 45.3489C151.607 55.6526 131.27 41.0884 135.883 22.6523Z" :fill="`url(#${uniqueID}paint9_linear_1442_184)`"/>
<path d="M28.7394 149.912C39.044 153.877 44.505 165.157 41.2239 175.699C35.5765 193.845 10.6314 195.709 2.35016 178.604C-5.93106 161.499 11.0028 143.087 28.7394 149.912Z" :fill="`url(#${uniqueID}paint10_linear_1442_184)`"/>
<path d="M86.1248 189.796C85.5298 177.065 98.9036 168.435 110.258 174.224C121.667 180.04 122.48 196.033 111.72 202.976C100.96 209.919 86.7226 202.587 86.1248 189.796Z" :fill="`url(#${uniqueID}paint11_linear_1442_184)`"/>
<path d="M82.3031 61.2816C92.2423 51.3425 108.357 51.3425 118.296 61.2816C128.235 71.2208 128.235 87.3354 118.296 97.2746C108.357 107.214 92.2423 107.214 82.3031 97.2746C72.3639 87.3354 72.3639 71.2208 82.3031 61.2816Z" fill="var(--dt-color-surface-contrast)"/>
<path d="M156.166 55.2415C162.311 49.8113 171.255 48.9561 178.318 53.123C185.382 57.29 188.959 65.5313 187.179 73.5368C185.398 81.5423 178.666 87.491 170.502 88.2717C162.338 89.0524 154.6 84.4875 151.335 76.9645C148.07 69.4416 150.02 60.6716 156.166 55.2415Z" :fill="`url(#${uniqueID}paint12_linear_1442_184)`"/>
</g>
<defs>
<linearGradient :id="`${uniqueID}paint0_linear_1442_184`" x1="43.2335" y1="115.459" x2="-8.06975" y2="59.8569" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.520863" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint1_linear_1442_184`" x1="65.8693" y1="105.101" x2="73.5958" y2="138.031" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.520863" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint2_linear_1442_184`" x1="60.335" y1="64.0604" x2="64.3475" y2="81.1615" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.520863" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint3_linear_1442_184`" x1="138.293" y1="70.9393" x2="142.305" y2="88.0404" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.520863" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint4_linear_1442_184`" x1="25.9411" y1="128.835" x2="29.9536" y2="145.936" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.520863" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint5_linear_1442_184`" x1="72.4676" y1="22.5976" x2="136.955" y2="30.0495" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.520863" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint6_linear_1442_184`" x1="141.853" y1="103.07" x2="164.865" y2="201.143" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.520863" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint7_linear_1442_184`" x1="61.7849" y1="-1.93197" x2="86.052" y2="70.2115" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.494814" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint8_linear_1442_184`" x1="120.536" y1="188.462" x2="39.6879" y2="164.934" gradientUnits="userSpaceOnUse">
<stop offset="0.297344" stop-color="#7C52FF"/>
<stop offset="0.762314" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint9_linear_1442_184`" x1="120.332" y1="78.4866" x2="200.869" y2="16.5788" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.510446" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint10_linear_1442_184`" x1="36.2115" y1="198.79" x2="-18.7005" y2="138.017" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.510446" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint11_linear_1442_184`" x1="115.017" y1="175.046" x2="80.8665" y2="205.636" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C52FF"/>
<stop offset="0.510446" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
<linearGradient :id="`${uniqueID}paint12_linear_1442_184`" x1="196.997" y1="90.2226" x2="157.544" y2="45.7756" gradientUnits="userSpaceOnUse">
<stop offset="0.297344" stop-color="#7C52FF"/>
<stop offset="0.762314" stop-color="#F9008E"/>
<stop offset="1" stop-color="#F6AB3C"/>
</linearGradient>
</defs>
</svg>

</template>

<script>
import { getUniqueString } from '@/src/utils';

export default {
  name: 'DtIllustrationBlackHole',

  props: {
    /**
     * The label of the illustration as read out by a screenreader. Leave this unset if your illustration is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the illustrations migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-illustration';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
